import { Component, Vue } from 'vue-property-decorator';

/**
 * An utility service for date.
 */
@Component
export default class DateUtils extends Vue {
  /**
   * Convert string 'dd/mm/yyyy' or 'dd-mm-yyy' to Date
   * @param dateString
   */
  convertStringToDate(dateString: string) {
    let dateParts = [];
    if (dateString.includes('/')) {
      dateParts = dateString.split('/');
    }
    if (dateString.includes('-')) {
      dateParts = dateString.split('-');
    }
    // @ts-ignore
    return new Date(`${dateParts[2]}-${this.formatMonth(dateParts[1])}-${this.formatMonth(dateParts[0])}T00:00:00.000Z`);
  }
  formatMonth(month: number) {
    return String(month).padStart(2, '0');
  }
}
